import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const PUBLIC_PATHS = ['/', '/login', '/verifier-email', '/mot-de-passe-oublie', '/reinitialiser-mot-de-passe', '/mfa-enrolement'];

const isPublicPath = () => {
  const path = window.location.pathname;
  return path.startsWith('/chantier/') || path.startsWith('/e/') || path.startsWith('/suivi/') || PUBLIC_PATHS.includes(path);
};

const clearSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
};

// Rafraîchissement single-flight : une seule requête de refresh à la fois,
// les appels concurrents attendent le même résultat.
let refreshPromise = null;

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    const status = err.response?.status;

    // 401 sur un appel API normal : tentative de refresh silencieux puis rejeu.
    const isAuthCall = original?.url?.includes('/auth/');
    if (status === 401 && original && !original._retry && !isAuthCall) {
      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        original._retry = true;
        try {
          if (!refreshPromise) {
            refreshPromise = axios
              .post(`${API_URL}/auth/refresh`, { refreshToken })
              .finally(() => { refreshPromise = null; });
          }
          const { data } = await refreshPromise;
          localStorage.setItem('token', data.token);
          localStorage.setItem('refreshToken', data.refreshToken);
          original.headers.Authorization = `Bearer ${data.token}`;
          return api(original);
        } catch {
          // refresh mort : déconnexion ci-dessous
        }
      }
      clearSession();
      if (!isPublicPath()) window.location.href = '/login';
    }

    return Promise.reject(err);
  }
);

export default api;
